import EditRequestJobPosting from './EditRequestJobPosting';

export default EditRequestJobPosting;
